import { round } from '@/utils/mathUtils';
import React from 'react';

type DiscountDisplayProps = {
  discountEdit?: number;
  discount?: number;
};

const DiscountDisplay: React.FC<DiscountDisplayProps> = ({
  discountEdit,
  discount,
}) => {
  const roundedEdit = discountEdit ? round(discountEdit, 2) : '-';
  const roundedDiscount = discount ? round(discount, 2) : '-';

  // Only show the strike-through price if both values are numbers and different.
  const showStrikethrough =
    typeof discountEdit === 'number' &&
    typeof discount === 'number' &&
    roundedEdit !== roundedDiscount;

  // Choose text color based on whether discount is greater than discountEdit.
  const discountColor =
    typeof discount === 'number' && typeof discountEdit === 'number'
      ? discount > discountEdit
        ? 'text-red-600' // error color
        : 'text-green-600' // success color
      : '';

  return (
    <div className="flex w-full flex-col items-center justify-center">
      <span className="h-5 text-lg">{roundedEdit}</span>
      {showStrikethrough && (
        <span className={`line-through ${discountColor}`}>
          {roundedDiscount}
        </span>
      )}
    </div>
  );
};

export default DiscountDisplay;
